import { Box, CircularProgress } from '@mui/material';

export const ScreenLoader = () => {
  return (
    <Box textAlign="center" position="sticky" top="40vh">
      <CircularProgress />
    </Box>
  );
};
